<template>
	<el-dialog width="900px" :visible.sync="visible" title="开票项目列表" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
		<el-card shadow="never" class="aui-card--fill">
			<div class="mod-plat__platinfouser}">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
					<el-form-item>
						<el-input v-model="dataForm.ticketProject" placeholder="开票项目" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
					</el-form-item>
				</el-form>
				<div class="checkUser" v-if="userList.length > 0">已设置:
					<el-tag v-for="(item,index) in userList" type="" @close="fnClose(item)" :key="item.ticketProId">{{item.ticketProject}}</el-tag>
				</div>
				<el-table ref="multipleTable" v-loading="dataListLoading" :data="dataList" :reserve-selection="true" @selection-change="dataListSelectionChangeHandle" :row-key="getRowKey" style="width: 100%;">
					<el-table-column type="selection" header-align="center" align="center" :reserve-selection="true" width="50"></el-table-column>
					<el-table-column label="序号" type="index" width="50" align="center">
						<template slot-scope="scope">
							<span>{{(page - 1) * limit + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ticketProject" label="开票项目" header-align="center" align="center"></el-table-column>
				</el-table>
				<el-pagination
					style="position: relative;padding-top: 15px;text-align: left;bottom:0"
					background
					:current-page="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="limit"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
					@size-change="pageSizeChangeHandle"
					@current-change="pageCurrentChangeHandle">
				</el-pagination>
			</div>
		</el-card>
  </el-dialog>
</template>

<script>
import { getDictDataList } from '@/utils'
import mixinViewModule from '@/mixins/view-module'
export default {
	mixins: [mixinViewModule],
	props:['settintUserList'],
	data () {
		return {
			rowSelectFlag:false,
			userList:'',
			selectList:getDictDataList('businessItems'),
			mixinViewModuleOptions: {
				getDataListURL: '/sys/plat/ticketPro/page',
				getDataListIsPage: true,
				deleteURL: '/sys/plat/info/user',
				deleteIsBatch: true
			},
			id: 0,
			visible: false,
			dataForm: {
				// dictTypeId:'1289513229072973825',
				ticketProject:'',
				bodyId:''
			},
			ids: []
		}
	},
	methods: {
		getRowKey(row) {
			return row.ticketProId;
		},
		init () {
			this.ids = []
			this.userList = []
			this.getDataList()
			this.visible = true
			this.$nextTick(() => {
				this.rowSelectFlag = true;
				this.$refs.multipleTable.clearSelection()
				this.settintUserList.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row,true);
				})
				this.userList = this.settintUserList
				this.rowSelectFlag = false;
			})
		},
		handleChange(e){
			this.dataForm.businessItem = e;
		},
		dataListSelectionChangeHandle (val) {
			if(this.rowSelectFlag) return
			this.userList = Array.from(new Set(val))
			this.$emit('handleUserList',val)
		},
		dataFormSubmitHandle () {
			if(this.userList.length == 0){
				return this.$message.error("请选择人员");
			}
			let ids = this.userList.filter(item => item.userId)
			this.$http.post('/sys/plat/task/assign', { taskId: this.id, userIdList: ids }).then(({ data: res }) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.$message({
					message: '分配成功',
					type: 'success',
					duration: 1000,
					onClose: () => {
						this.visible = false
						this.$emit('refreshDataList')
					}
				})
			}).catch(() => {})
		},
		//   删除用户
		fnClose(obj){
			console.log(obj)
			let newArrUser = [];
			this.userList.map((item,index) => {
				if(obj.id == item.id){
					newArrUser.push(item)
				}
			})
			newArrUser.forEach(row => {
				this.$refs.multipleTable.toggleRowSelection(row);
			});
		}
	}
}
</script>
<style lang="scss">
.checkUser{
	padding-top: 10px;
	color:#188eee;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	span{
		// background: #55abf1;
		// color: #fff;
		// padding: 3px 10px;
		// border-radius: 10px;
		// margin-bottom: 5px;
		margin-right: 7px;
	}
}
</style>